import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { ConfigurationServices } from '../../../configuration/services';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { ConfigurationVariationCreateListPage } from '../../../configuration/configuration-variations/configuration-variations-create/configuration-variation-create-list/configuration-variation-create-list';
/**
 * Generated class for the DishListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-variations-partial-fav-select',
    templateUrl: 'variations-partial-fav-select.html',
})
export class VariationsPartialFavSelectPage {
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        private toastCtrl: ToastController,
        public translate: TranslateService,
        public configurationServices: ConfigurationServices) {
    }

    insert(variation) {
        //Funcion que añadir al array de ingredientes seleccionados para el Food cost
        if (!this.check(variation.UID)) { //Buscamos si el ingrediente ya esta anadido
            var _array = Array();
            _array.push(variation.UID); //UID
            _array.push(variation.name); //Name
            _array.push(variation.price); //Precio
            _array.push(variation.type); //Precio
            this.configurationServices.fav_variations_array_tmp.push(_array);
            this.configurationServices.fav_variations_array_tmp = [...this.configurationServices.fav_variations_array_tmp];
            let toast = this.toastCtrl.create({
                message: this.translate.instant('config-variations-create-info-variacion') + ' ' + variation.name + ' ' + this.translate.instant('instant-anadido-correctemente'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-variacion-esta-anadida-lista'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    check(value) {
        var response = false;
        for (var i = 0; i < this.configurationServices.fav_variations_array_tmp.length; i++) {
            var obj = this.configurationServices.fav_variations_array_tmp[i];
            if (obj[0] == value) {
                response = true;
            }
        }
        return response;
    }
    nextPage() {
        if (this.configurationServices.page_active < this.configurationServices.pagesVariations.length) {
            this.configurationServices.page_active += 1
        }
        this.configurationServices.getListVariations();

    }
    previusPage() {
        if (this.configurationServices.page_active > 1) {
            this.configurationServices.page_active -= 1;
        }
        this.configurationServices.getListVariations();
    }
    activePage(number) {
        this.configurationServices.page_active = number;
        this.configurationServices.getListVariations();
    }
    createVariation() {
        this.navCtrl.push(ConfigurationVariationCreateListPage, {
            type: 'all'
        });
    }
    clickElement(event) {
        if (event.type == 'click') {
            this.insert(event.row);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/variations/variations-create-fav-select/variations-partial-fav-select/variations-partial-fav-select.ts